import type {PartialOptions} from "../../../stem-core/ui/UIBase";
import {UI} from "../../../stem-core/ui/UIBase";
import {isFunction, evaluateSprintf} from "../../../stem-core/base/Utils.js";
import {convertHTMLStringToJSON} from "../../UtilsLib";
import {PanelLink} from "../../panel/panel-elements/PanelLink.jsx";


export function convertToUI(value: any, classMap: Map<string, any>, inRecursion = false): any {
    if (typeof value === "string") {
        return inRecursion ? new UI.TextElement(value) : new (classMap.get("Text"))(value);
    }
    if (!value) {
        return null;
    }
    if (Array.isArray(value)) {
        return value.map(x => convertToUI(x, classMap, inRecursion));
    }
    const options = {...value};
    let children = [];
    if (options.children) {
        children = convertToUI(options.children, classMap, true);
        delete options.children;
    }
    if (options.class) {
        options.className = options.class;
        delete options.class;
    }
    if (options.classname) {
        options.className = options.classname;
        delete options.classname;
    }

    const classMapEntry = [...classMap.entries()].find(([key]) => key.toUpperCase() === value.tag.toUpperCase());
    if (!classMapEntry) {
        return null;
    }
    const classObject = classMapEntry[1];
    if (classObject.prototype instanceof UI.Element) {
        return UI.createElement(classObject, options, ...children);
    }
    return classObject(options, children);
}

const MessageValidTags = new Map<string, any>([
    ["b", UI.Primitive("b")],
    ["i", UI.Primitive("i")],
    ["a", PanelLink],
    ["Text", UI.TextElement]
]);

interface MessageElementOptions {
    args?: any[];
    message?: any;
}

export class MessageElement extends UI.Element<MessageElementOptions> {
    getDefaultOptions(): PartialOptions<MessageElement> {
        return {
            ...super.getDefaultOptions(),
            message: "",
            args: [],
        }
    }

    getMessage() {
        const {message, args} = this.options;
        if (isFunction(message)) {
            return message(...args);
        }
        if (args?.length > 0 && message.indexOf("%1") !== -1) {
            return evaluateSprintf(message, ...args);
        }
        return message;
    }

    render() {
        const message = this.getMessage();

        const messageObject = convertHTMLStringToJSON(message);

        return convertToUI(messageObject, MessageValidTags);
    }
}
